import type { Collection } from './models/collection';
import type { Index } from './models/indexes';

export function calculateCollectionStatus(collection: Collection) {
  const indexStatuses = collection.indexes.map((index) => calculateIndexStatus(collection, index));

  return {
    isDefined: collection.isDefined,
    hasMissing: indexStatuses.some((index) => index.isDefined && !index.isComplete),
    hasUndefined: indexStatuses.some((index) => !index.isDefined),
  };
}

export function calculateIndexStatus(collection: Collection, index: Index) {
  const indentical = index.actual.filter((x) => index.isDefined && x.hash === index.hash).length;
  const different = index.actual.filter((x) => index.isDefined && x.hash !== index.hash).length;
  const missing = collection.actual.length - (indentical + different);

  return {
    isDefined: index.isDefined,
    isComplete: indentical === collection.actual.length,
    indentical,
    missing,
    different,
  };
}
